'use strict'

module.exports = (message, datasetId) => `${message} (${datasetId})`



// WEBPACK FOOTER //
// ./helpers/createBreadcrumbMessage.js